import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { QuickSearchLayerCheckStateService } from '@lassi/webapp-shared';
import { LEAFLET_CONTROL_DIRECTIVE } from '../map-tools/leaflet-control.directive';
import { QuickSearchLayerCheckComponent } from './quick-search-layer-check.component';

@Component({
  selector: 'lassi-quick-search-layer-panel',
  imports: [QuickSearchLayerCheckComponent, MatButtonModule, MatIcon],
  hostDirectives: [LEAFLET_CONTROL_DIRECTIVE],
  template: `
    @if (layerCheckState.missingLayers().length > 0 && !dismissed()) {
      <div class="layer-check-panel">
        <lassi-quick-search-layer-check />
        <button mat-icon-button class="close-btn" (click)="dismissed.set(true)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  `,
  styles: `
    :host {
      display: contents;
    }

    .layer-check-panel {
      display: flex;
      align-items: center;
      background-color: var(--mdc-theme-surface, white);
      border-radius: 4px;
      box-shadow: var(--mat-app-elevation-shadow-level-3);
      overflow: hidden;
      margin-left: 10px;
      margin-top: 10px;
      width: 75%;
    }

    .close-btn {
      flex-shrink: 0;
      margin-right: 4px;
      margin-left: 0;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickSearchLayerPanelComponent {
  readonly layerCheckState = inject(QuickSearchLayerCheckStateService);
  readonly dismissed = signal(false);

  private readonly missingLayersKey = signal('');

  constructor() {
    effect(() => {
      const layers = [...this.layerCheckState.missingLayers()].sort((a, b) =>
        a.localeCompare(b),
      );
      const nextKey = layers.join('|');
      if (layers.length > 0 && this.missingLayersKey() !== nextKey) {
        this.dismissed.set(false);
      }
      this.missingLayersKey.set(nextKey);
    });
  }
}
